import React from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale } from "../../data/constants";
import { GetTranslation } from "../../translations/GetTranslation";

type LastModificationInfoProps = {
  lastModifiedBy: string | undefined;
  lastModifiedOnUtc: string | undefined;
};

export default function LastModificationInfo({ lastModifiedBy, lastModifiedOnUtc }: LastModificationInfoProps) {
  const intl = useIntl();

  if (!lastModifiedBy && !lastModifiedOnUtc) {
    return null;
  }

  const modifiedOn = lastModifiedOnUtc
    ? `${GetTranslation(intl, "common.lastModification.on")} ${new Date(lastModifiedOnUtc).toLocaleString(
        SwissGermanLocale
      )} `
    : "";

  const modifiedBy = lastModifiedBy ? `${GetTranslation(intl, "common.lastModification.by")} ${lastModifiedBy}` : "";

  return (
    <span style={{ fontStyle: "italic" }}>
      {GetTranslation(intl, "common.lastModification")} {modifiedOn}
      {modifiedBy}
    </span>
  );
}
